module.exports = __webpack_public_path__ + "img/leaf.58b2ce00.svg";